import { Space } from "antd-mobile"
import { ButtonView } from "./factory/ViewUtil"
export const NotFound = ({gohome})=> {
    return (
        <div style={{
            width : '100vw', 
            height: '100vh',
            display : 'flex',
            alignItems : 'center',
            justifyContent : 'center'}}>
                <Space direction='vertical' style={{'--gap-vertical' : '20px', textAlign: 'center'}}>
                    <div style={{fontSize : '30px', fontWeight : 'bold', }}>404</div>
                    <div style={{color : 'gray'}}>Page not found</div>
                    <ButtonView onClick={()=>{gohome()}}>Go Homepage</ButtonView>
                </Space>
        </div>
    )
}